var exports = {
  "k": "xe564cbfb--335fb9--container",
};

module.exports = exports;
